import { computed } from 'vue'

import type { ComputedRef } from 'vue'

import { TutorKanbanStage } from '@brighterly/lib-core-types/tutor-kanban/enums'

import { useTutorKanbanStore } from './store'
import { isTutorKanbanExitStage } from '../config/tutor-kanban-exit-stage.const'

interface TutorKanbanExitConfirmReturn {
  isCategoryConfirmRequired: ComputedRef<boolean>
  isReasonConfirmRequired: ComputedRef<boolean>
  isFinalDayChanged: ComputedRef<boolean>
  isFinalDayConfirmRequired: ComputedRef<boolean>
}

export const useTutorKanbanExitConfirm = (): TutorKanbanExitConfirmReturn => {
  const tutorKanbanStore = useTutorKanbanStore()

  const isConfirmScope = computed<boolean>(() => {
    const stage = tutorKanbanStore.getStage
    const savedStage = tutorKanbanStore.getSavedStage

    if (!stage || !savedStage) return false

    if (savedStage === TutorKanbanStage.ProbationFailed) {
      return stage === TutorKanbanStage.ProbationFailed
    }

    return isTutorKanbanExitStage(savedStage) && isTutorKanbanExitStage(stage)
  })

  const isCategoryConfirmRequired = computed<boolean>(() => {
    return isConfirmScope.value && tutorKanbanStore.getSavedStageCategories.length > 0
  })

  const isReasonConfirmRequired = computed<boolean>(() => {
    return isConfirmScope.value && tutorKanbanStore.getSavedStageReasons.length > 0
  })

  const isFinalDayChanged = computed<boolean>(() => {
    return tutorKanbanStore.getExitDate !== tutorKanbanStore.getSavedExitDate
  })

  const isFinalDayConfirmRequired = computed<boolean>(() => {
    if (tutorKanbanStore.getStage !== TutorKanbanStage.ExitDecisionRequest) return false
    if (!tutorKanbanStore.getExitDate) return false

    return isFinalDayChanged.value || tutorKanbanStore.getSavedStage !== TutorKanbanStage.ExitDecisionRequest
  })

  return {
    isCategoryConfirmRequired,
    isReasonConfirmRequired,
    isFinalDayChanged,
    isFinalDayConfirmRequired,
  }
}
